export default __webpack_public_path__ + "static/media/google-play-store-download.1d8f7bc8.svg";